@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.searchHolder {
  pointer-events: initial;
  z-index: 1;
  width: 100%;
  display: flex;
  justify-content: center;
  transition: all 200ms ease;
  position: sticky;
  top: 0;
  padding-top:  hevo-toolkit-variables.$spacer * 1.25;
  .gradientBackdrop {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    opacity: 0;
    z-index: 0;
    &::after {
      content: '';
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      transition: opacity 200ms ease;
      padding-bottom:  hevo-toolkit-variables.$spacer * 1.25;
      background-image: linear-gradient(
        to bottom,
         hevo-toolkit-variables.$surface-bg,
         hevo-toolkit-variables.$surface-bg,
         hevo-toolkit-variables.$surface-bg-0
      );
    }
  }

  &.fixedPosition {
    & [data-id='search-box'] {
      box-shadow:  hevo-toolkit-variables.$shadow-elevated;
    }

    .gradientBackdrop {
      opacity: 1;
    }
  }
}
